export const CART_CHANGED_EVENT = 'cart:changed';

export const notifyCartChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CART_CHANGED_EVENT));
};
